import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class Contract extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/user/contract'
    super(store, path)
  }
}
